import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, model, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Address, PriceListType, Product } from '../../../../generated/generated-types';
import { PriceListEntryListWidgetComponent } from '../price-list-entry-list-widget/price-list-entry-list-widget.component';

@Component({
  selector: 'app-formly-price-entries',
  imports: [
    PriceListEntryListWidgetComponent,
    BlockableDiv,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ],
  templateUrl: './formly-price-entries.component.html',
  styleUrl: './formly-price-entries.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyPriceEntriesComponent extends FieldType implements OnInit {

  private readonly cdRef = inject(ChangeDetectorRef);

  isCustomer = model<boolean>(false);
  customerAddressId = model<string>(null);
  vendorAddressId = model<string>(null);
  debitorIdentifier = model<string>(null);
  creditorIdentifier = model<string>(null);
  product = model<Product>(null);
  PriceListType = PriceListType;

  isSaving = signal(false);

  ngOnInit(): void {
    if (this.isCustomer() || this.props.isCustomer) {
      this.customerAddressId.set(this.model.id);
      this.debitorIdentifier.set(this.model?.debitor?.identifier);
    } else {
      this.vendorAddressId.set(this.model.id);
      this.creditorIdentifier.set(this.model?.creditor?.identifier);
    }
  }

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error('No detail component found to save address');
      return;
    }

    this.isSaving.set(true);
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving.set(false);
    this.cdRef.detectChanges();

    if (this.isCustomer() || this.props.isCustomer) {
      this.customerAddressId.set(this.model.id);
      this.debitorIdentifier.set(this.model?.debitor?.identifier);
    } else {
      this.vendorAddressId.set(this.model.id);
      this.creditorIdentifier.set(this.model?.creditor?.identifier);
    }
  }

}
